// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== FEED CONTAINER ==================== */

.uacf-feed-container {
  position: relative;
  width: 100%;
  height: auto;
  padding: 1rem;
  box-sizing: border-box;
  /* max-width: 1500px; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 1.5rem;
  border-radius: 10px;
  margin-bottom: 3rem; /* ✅ Space for footer */
  overflow: visible; /* ✅ Allow content to flow */
}

/* ==================== USER FEED ==================== */

.uacf-user-feed {
  position: relative;
  width: 100%;
  height: auto; /* ✅ Changed from 100% to auto */
  box-sizing: border-box;
  background: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  border-radius: 10px;
}

/* ==================== POST CARD ==================== */

.uacf-post-card {
  height: auto;
  width: 100%;
  border-radius: 10px;
  background: none;
  box-shadow: 1px 2px 1px rgba(25, 24, 24, 0.1);
  margin-bottom: 1.5rem; /* ✅ Space between posts */
}

/* ==================== USER CONTAINER ==================== */

.uacf-user-container {
  width: 100%;
  background: none;
  height: auto;
  min-height: 60px;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.uacf-user-info-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.uacf-user-avatar-wrapper {
  width: 40px;
  height: 40px;
  margin-left: 0.5rem;
  flex-shrink: 0;
}

.uacf-user-name-wrapper {
  margin-left: 0.75rem;
  flex: 1 1;
}

.uacf-user-link {
  text-decoration: none;
  color: inherit;
}

.uacf-user-action {
  display: flex;
  position: absolute;
  right: 0;
  gap: 0.5rem;
  align-items: center;
}

/* ==================== LOCATION & TIME ==================== */

.uacf-location-time-wrapper {
  display: flex;
  flex-direction: row;
  height: auto;
  min-height: 30px;
  margin-bottom: 0.5rem;
}

.uacf-feed-header {
  min-height: 10px;
  height: auto;
  width: 100%;
  font-size: 1rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  background: none;
  margin-left: 0.5rem;
}

.uacf-location-link {
  color: white;
  text-decoration: none;
}

/* ==================== FEED MEDIA ==================== */

.uacf-feed-media {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 1rem;
  width: 100%;
  height: auto;
  margin: 0.75rem 0;
  text-align: left;
  background: none;
  box-sizing: border-box;
}

.uacf-post-description {
  margin-left: 0.5rem;
  margin-bottom: 1rem;
}

.uacf-feed-media-container {
  width: 100%;
  height: auto;
  border-radius: 12px;
  margin-top: 1rem;
  overflow: hidden;
}

.uacf-media-img {
  width: 100%;
  max-width: 960px;
  height: auto;
  border-radius: 8px;
}

.uacf-media-video {
  width: 100%;
  max-width: 900px;
  height: auto;
  border-radius: 8px;
}

/* ==================== POST STATS ==================== */

.uacf-post-stats-wrapper {
  display: flex;
  gap: 1rem;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;
}

.uacf-post-stats-left {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  width: 100%;
  height: auto;
  min-height: 30px;
  overflow: hidden;
  align-items: center;
  padding: 5px;
}

.uacf-post-stats-right {
  width: 50%;
  height: 100%;
  min-height: 30px;
  overflow: hidden;
  text-align: right;
}

.uacf-impressions-text {
  font-size: 1rem;
  color: white;
  font-weight: normal;
}

/* ==================== COMMENTS SECTION ==================== */

.uacf-comments-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 1rem;
  padding-bottom: 1rem; /* ✅ Extra space at bottom */
}

.uacf-feed-comments {
  width: 100%;
  margin-bottom: 1rem;
}

.uacf-comments-title {
  font-weight: normal;

}

.comments-container {
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 0.5rem;
  scrollbar-width: none; /* ✅ Hide scrollbar Firefox */
  -ms-overflow-style: none; /* ✅ Hide scrollbar IE/Edge */
}

.comments-container::-webkit-scrollbar {
  display: none; /* ✅ Hide scrollbar Chrome/Safari */
}

.uacf-comment-item {
  margin-bottom: 0.5rem;
  height: auto;
  min-height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.uacf-comment-link {
  text-decoration: none;
  color: inherit;
}

.uacf-no-comments {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.uafc-comment-time {
  font-size: 1rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: rgb(32, 21, 21);
}

/* ==================== ADD COMMENT ==================== */

.uacf-add-comment {
  width: 100%;
  height: auto;
  min-height: 50px;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 12px;
  margin-top: 0px;
  box-sizing: border-box;
}

.uafc-comment-input {
  flex: 1 1;
  background-color: rgb(50, 50, 50);
  color: white;
  border: 1px solid #444;
  border-radius: 10px;
  outline: none;
  font-size: 1rem;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.uafc-comment-input::placeholder {
  color: #bbb;
  font-weight: normal;
}

.uafc-add-comment-button {
  width: auto;
  min-width: 80px;
  height: auto;
  padding: 0.75rem 1.5rem;
  background-color: rgb(60, 60, 60);
  color: white;
  border: 2px solid #444;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s ease, transform 0.2s ease;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 500;
}

.uafc-add-comment-button:hover {
  background-color: #3c3d3d;
  transform: scale(1.05);
}

/* ==================== LOADING STATE ==================== */

.uacf-loading {
  text-align: center;
  padding: 2rem;
  color: rgba(255, 255, 255, 0.6);
}

/* ==================== MAIN FEED ==================== */

.uacf-main-feed {
  margin-top: 10px;
}

/* ==================== RESPONSIVE ==================== */

@media (max-width: 768px) {
  .uacf-feed-container {
    padding: 0.75rem;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .uacf-post-card {
    padding: 0.75rem;
    margin-bottom: 1rem;
  }

  .uacf-feed-header {
    font-size: 0.9rem;
  }

  .uafc-post-stats-left {
    gap: 1rem;
  }

  .uacf-impressions-text {
    font-size: 0.875rem;
  }

  .uafc-comment-input {
    font-size: 0.9rem;
    padding: 0.6rem;
  }

  .uafc-add-comment-button {
    min-width: 60px;
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .uacf-feed-container {
    padding: 0.5rem;
    gap: 0.75rem;
    margin-bottom: 1.5rem;
  }

  .uacf-post-card {
    padding: 0.5rem;
  }

  .uacf-user-avatar-wrapper {
    width: 32px;
    height: 32px;
  }

  .uafc-post-stats-left {
    gap: 0.75rem;
    flex-wrap: wrap;
  }

  .uacf-add-comment {
    flex-direction: column;
    align-items: stretch;
  }

  .uafc-add-comment-button {
    width: 100%;
  }
}

.uaf-profile-menu-dropdown {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  margin-top: 40px;
  margin-left: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UAFeedContent.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;EACnB,mBAAmB,EAAE,uBAAuB;EAC5C,iBAAiB,EAAE,4BAA4B;AACjD;;AAEA,wDAAwD;;AAExD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY,EAAE,gCAAgC;EAC9C,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,wDAAwD;;AAExD;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA,6DAA6D;;AAE7D;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,SAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf;wEACsE;EACtE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,yDAAyD;;AAEzD;EACE;wEACsE;EACtE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,yDAAyD;;AAEzD;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,oBAAoB,EAAE,4BAA4B;AACpD;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;;AAErB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB,EAAE,6BAA6B;EACpD,wBAAwB,EAAE,6BAA6B;AACzD;;AAEA;EACE,aAAa,EAAE,mCAAmC;AACpD;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf;wEACsE;EACtE,sBAAsB;AACxB;;AAEA,0DAA0D;;AAE1D;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf;wEACsE;AACxE;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,2DAA2D;EAC3D;wEACsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,4DAA4D;;AAE5D;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA,wDAAwD;;AAExD;EACE,gBAAgB;AAClB;;AAEA,yDAAyD;;AAEzD;EACE;IACE,gBAAgB;IAChB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":["/* ==================== FEED CONTAINER ==================== */\n\n.uacf-feed-container {\n  position: relative;\n  width: 100%;\n  height: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n  /* max-width: 1500px; */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 1.5rem;\n  border-radius: 10px;\n  margin-bottom: 3rem; /* ✅ Space for footer */\n  overflow: visible; /* ✅ Allow content to flow */\n}\n\n/* ==================== USER FEED ==================== */\n\n.uacf-user-feed {\n  position: relative;\n  width: 100%;\n  height: auto; /* ✅ Changed from 100% to auto */\n  box-sizing: border-box;\n  background: none;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  border-radius: 10px;\n}\n\n/* ==================== POST CARD ==================== */\n\n.uacf-post-card {\n  height: auto;\n  width: 100%;\n  border-radius: 10px;\n  background: none;\n  box-shadow: 1px 2px 1px rgba(25, 24, 24, 0.1);\n  margin-bottom: 1.5rem; /* ✅ Space between posts */\n}\n\n/* ==================== USER CONTAINER ==================== */\n\n.uacf-user-container {\n  width: 100%;\n  background: none;\n  height: auto;\n  min-height: 60px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.uacf-user-info-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n}\n\n.uacf-user-avatar-wrapper {\n  width: 40px;\n  height: 40px;\n  margin-left: 0.5rem;\n  flex-shrink: 0;\n}\n\n.uacf-user-name-wrapper {\n  margin-left: 0.75rem;\n  flex: 1;\n}\n\n.uacf-user-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.uacf-user-action {\n  display: flex;\n  position: absolute;\n  right: 0;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n/* ==================== LOCATION & TIME ==================== */\n\n.uacf-location-time-wrapper {\n  display: flex;\n  flex-direction: row;\n  height: auto;\n  min-height: 30px;\n  margin-bottom: 0.5rem;\n}\n\n.uacf-feed-header {\n  min-height: 10px;\n  height: auto;\n  width: 100%;\n  font-size: 1rem;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  background: none;\n  margin-left: 0.5rem;\n}\n\n.uacf-location-link {\n  color: white;\n  text-decoration: none;\n}\n\n/* ==================== FEED MEDIA ==================== */\n\n.uacf-feed-media {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-size: 1rem;\n  width: 100%;\n  height: auto;\n  margin: 0.75rem 0;\n  text-align: left;\n  background: none;\n  box-sizing: border-box;\n}\n\n.uacf-post-description {\n  margin-left: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.uacf-feed-media-container {\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n  margin-top: 1rem;\n  overflow: hidden;\n}\n\n.uacf-media-img {\n  width: 100%;\n  max-width: 960px;\n  height: auto;\n  border-radius: 8px;\n}\n\n.uacf-media-video {\n  width: 100%;\n  max-width: 900px;\n  height: auto;\n  border-radius: 8px;\n}\n\n/* ==================== POST STATS ==================== */\n\n.uacf-post-stats-wrapper {\n  display: flex;\n  gap: 1rem;\n  flex-direction: column;\n  width: 100%;\n  margin: 1rem 0;\n}\n\n.uacf-post-stats-left {\n  display: flex;\n  flex-direction: row;\n  gap: 2rem;\n  width: 100%;\n  height: auto;\n  min-height: 30px;\n  overflow: hidden;\n  align-items: center;\n  padding: 5px;\n}\n\n.uacf-post-stats-right {\n  width: 50%;\n  height: 100%;\n  min-height: 30px;\n  overflow: hidden;\n  text-align: right;\n}\n\n.uacf-impressions-text {\n  font-size: 1rem;\n  color: white;\n  font-weight: normal;\n}\n\n/* ==================== COMMENTS SECTION ==================== */\n\n.uacf-comments-wrapper {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 1rem;\n  padding-bottom: 1rem; /* ✅ Extra space at bottom */\n}\n\n.uacf-feed-comments {\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.uacf-comments-title {\n  font-weight: normal;\n\n}\n\n.comments-container {\n  width: 100%;\n  max-height: 400px;\n  overflow-y: auto;\n  padding-right: 0.5rem;\n  scrollbar-width: none; /* ✅ Hide scrollbar Firefox */\n  -ms-overflow-style: none; /* ✅ Hide scrollbar IE/Edge */\n}\n\n.comments-container::-webkit-scrollbar {\n  display: none; /* ✅ Hide scrollbar Chrome/Safari */\n}\n\n.uacf-comment-item {\n  margin-bottom: 0.5rem;\n  height: auto;\n  min-height: 30px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.uacf-comment-link {\n  text-decoration: none;\n  color: inherit;\n}\n\n.uacf-no-comments {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n.uafc-comment-time {\n  font-size: 1rem;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  color: rgb(32, 21, 21);\n}\n\n/* ==================== ADD COMMENT ==================== */\n\n.uacf-add-comment {\n  width: 100%;\n  height: auto;\n  min-height: 50px;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  border-radius: 12px;\n  margin-top: 0px;\n  box-sizing: border-box;\n}\n\n.uafc-comment-input {\n  flex: 1;\n  background-color: rgb(50, 50, 50);\n  color: white;\n  border: 1px solid #444;\n  border-radius: 10px;\n  outline: none;\n  font-size: 1rem;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n}\n\n.uafc-comment-input::placeholder {\n  color: #bbb;\n  font-weight: normal;\n}\n\n.uafc-add-comment-button {\n  width: auto;\n  min-width: 80px;\n  height: auto;\n  padding: 0.75rem 1.5rem;\n  background-color: rgb(60, 60, 60);\n  color: white;\n  border: 2px solid #444;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n  font-weight: 500;\n}\n\n.uafc-add-comment-button:hover {\n  background-color: #3c3d3d;\n  transform: scale(1.05);\n}\n\n/* ==================== LOADING STATE ==================== */\n\n.uacf-loading {\n  text-align: center;\n  padding: 2rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* ==================== MAIN FEED ==================== */\n\n.uacf-main-feed {\n  margin-top: 10px;\n}\n\n/* ==================== RESPONSIVE ==================== */\n\n@media (max-width: 768px) {\n  .uacf-feed-container {\n    padding: 0.75rem;\n    gap: 1rem;\n    margin-bottom: 2rem;\n  }\n\n  .uacf-post-card {\n    padding: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .uacf-feed-header {\n    font-size: 0.9rem;\n  }\n\n  .uafc-post-stats-left {\n    gap: 1rem;\n  }\n\n  .uacf-impressions-text {\n    font-size: 0.875rem;\n  }\n\n  .uafc-comment-input {\n    font-size: 0.9rem;\n    padding: 0.6rem;\n  }\n\n  .uafc-add-comment-button {\n    min-width: 60px;\n    padding: 0.6rem 1rem;\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .uacf-feed-container {\n    padding: 0.5rem;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .uacf-post-card {\n    padding: 0.5rem;\n  }\n\n  .uacf-user-avatar-wrapper {\n    width: 32px;\n    height: 32px;\n  }\n\n  .uafc-post-stats-left {\n    gap: 0.75rem;\n    flex-wrap: wrap;\n  }\n\n  .uacf-add-comment {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .uafc-add-comment-button {\n    width: 100%;\n  }\n}\n\n.uaf-profile-menu-dropdown {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 15px;\n  margin-top: 40px;\n  margin-left: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
